"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactMeasure = _interopRequireDefault(require("react-measure"));

var _reactMotion = require("react-motion");

var _core = require("@nivo/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const TOOLTIP_OFFSET = 14;
const tooltipStyle = {
  pointerEvents: 'none',
  position: 'absolute',
  zIndex: 10,
  top: 0,
  left: 0
};
const TooltipWrapper = (0, _react.memo)(({
  position,
  anchor,
  children
}) => {
  const _useState = (0, _react.useState)(null),
        dimensions = _useState[0],
        setDimensions = _useState[1];

  const theme = (0, _core.useTheme)();

  const _useMotionConfig = (0, _core.useMotionConfig)(),
        animate = _useMotionConfig.animate,
        springConfig = _useMotionConfig.springConfig;

  let x = Math.round(position[0]);
  let y = Math.round(position[1]);

  if (dimensions !== null) {
    if (anchor === 'top') {
      x -= dimensions[0] / 2;
      y -= dimensions[1] + TOOLTIP_OFFSET;
    } else if (anchor === 'right') {
      x += TOOLTIP_OFFSET;
      y -= dimensions[1] / 2;
    } else if (anchor === 'bottom') {
      x -= dimensions[0] / 2;
      y += TOOLTIP_OFFSET;
    } else if (anchor === 'left') {
      x -= dimensions[0] + TOOLTIP_OFFSET;
      y -= dimensions[1] / 2;
    } else if (anchor === 'center') {
      x -= dimensions[0] / 2;
      y -= dimensions[1] / 2;
    }
  }

  const style = (0, _react.useMemo)(() => _extends({}, tooltipStyle, {}, theme.tooltip, {
    transform: "translate(" + x + "px, " + y + "px)",
    opacity: dimensions === null ? 0 : 1
  }), [x, y, dimensions, theme.tooltip]); // if we don't have dimensions yet, we use
  // the non animated version with a 0 opacity
  // to avoid a flash effect and weird initial transition

  if (animate !== true || dimensions === null) {
    return _react.default.createElement(_reactMeasure.default, {
      client: false,
      offset: false,
      bounds: true,
      margin: false,
      onResize: ({
        bounds
      }) => {
        setDimensions([bounds.width, bounds.height]);
      }
    }, ({
      measureRef
    }) => _react.default.createElement("div", {
      ref: measureRef,
      style: style
    }, children));
  }

  return _react.default.createElement(_reactMotion.Motion, {
    style: {
      x: (0, _reactMotion.spring)(x, springConfig),
      y: (0, _reactMotion.spring)(y, springConfig)
    }
  }, animatedPosition => _react.default.createElement(_reactMeasure.default, {
    client: false,
    offset: false,
    bounds: true,
    margin: false,
    onResize: ({
      bounds
    }) => {
      setDimensions([bounds.width, bounds.height]);
    }
  }, ({
    measureRef
  }) => _react.default.createElement("div", {
    ref: measureRef,
    style: _extends({}, tooltipStyle, {}, theme.tooltip, {
      transform: "translate3d(" + animatedPosition.x + "px, " + animatedPosition.y + "px, 0)"
    })
  }, children)));
});
TooltipWrapper.displayName = 'TooltipWrapper';
TooltipWrapper.propTypes = process.env.NODE_ENV !== "production" ? {
  position: _propTypes.default.array.isRequired,
  anchor: _propTypes.default.oneOf(['top', 'right', 'bottom', 'left', 'center']).isRequired,
  children: _propTypes.default.node.isRequired
} : {};
TooltipWrapper.defaultProps = {
  anchor: 'top'
};
var _default = TooltipWrapper;
exports.default = _default;
module.exports = exports.default;